import React, { useEffect } from "react";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";

// Accessible modal / dialog. Sharp edges, brutalist border, backdrop blur.
const Modal = ({ open, onClose, title, children, size = "md", testId }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  const widths = {
    sm: "max-w-md",
    md: "max-w-lg",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
  };

  return (
    <div
      className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-0 sm:p-4"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      data-testid={testId}
    >
      <div
        className="absolute inset-0 bg-ink/60 backdrop-blur-sm animate-fade-in"
        onClick={onClose}
        data-testid="modal-backdrop"
      />
      <div
        className={cn(
          "relative w-full bg-paper border border-ink max-h-[90vh] overflow-y-auto animate-fade-up",
          widths[size]
        )}
      >
        <div className="flex items-center justify-between border-b border-ink px-5 py-4 sticky top-0 bg-paper z-10">
          <h2 className="font-display text-2xl uppercase tracking-tight">
            {title}
          </h2>
          <button
            onClick={onClose}
            aria-label="Close"
            data-testid="modal-close-btn"
            className="p-1 hover:text-brand-dark transition-colors"
          >
            <X size={22} />
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
